import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Typography from '../../base/Typography';
import CheckmarkBoldIcon from '../../icons/utility/CheckmarkBold';

export const ULStyled = styled.ul`
  padding: 0 0 0 ${rem(40)};
`;

export const LIStyled = styled.li`
  list-style: none;
  position: relative;
`;

export const IconStyled = styled(CheckmarkBoldIcon)`
${({ theme }) => {
    const largeUp = theme.useMediaQuery(theme.breakpoints.up('large'));
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let top = 2;
    if (largeUp) {
      top = 5;
    } else if (mediumUp) {
      top = 5;
    }

    return css`
    position: absolute;
    padding-right: .5rem;
    /* These top/left values will need to be adjusted once we throw the correct checkmark icon in. */
    top: ${rem(top)}; 
    left: ${rem(-40)};
  `;
  }
}
`;

export const TypographyListItemHeader = styled(Typography)`
  padding-bottom: ${rem(10)};
`;
